import React, { useEffect } from "react";

export const ArsenalHubPrivacyPolicy = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ background: '#f9fafb', minHeight: '100vh', padding: '60px 20px' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        {/* Header Card */}
        <div style={{
          background: 'linear-gradient(135deg, #334155 0%, #1e293b 100%)',
          padding: '50px 40px',
          borderRadius: '16px',
          marginBottom: '40px',
          color: '#fff',
          textAlign: 'center',
          boxShadow: '0 10px 40px rgba(0,0,0,0.1)'
        }}>
          <i className="fa-solid fa-shield-halved" style={{ fontSize: '48px', marginBottom: '20px', color: '#94a3b8' }}></i>
          <h1 style={{ fontSize: '36px', marginBottom: '10px', color: '#fff', fontWeight: '700' }}>
            Política de Privacidade do ArsenalHub
          </h1>
          <p style={{ color: '#cbd5e1', fontSize: '14px', opacity: '0.9', fontStyle: 'italic', margin: 0 }}>
            Última atualização: Junho de 2026
          </p>
        </div>

        {/* Content Card */}
        <div style={{
          background: '#fff',
          padding: '50px 40px',
          borderRadius: '16px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          lineHeight: '1.8',
          fontSize: '15px',
          color: '#374151'
        }}>
          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '0',
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            1. Introdução
          </h2>
          <p style={{ textAlign: 'justify', marginBottom: '24px' }}>
            O ArsenalHub é um aplicativo de gestão de acervo para CACs (Atiradores, Caçadores e Colecionadores) 
            autorizados pela Polícia Federal do Brasil. Esta Política de Privacidade descreve como coletamos, 
            usamos, armazenamos e protegemos seus dados pessoais em conformidade com a Lei Geral de Proteção de 
            Dados (LGPD) e diretrizes internacionais de privacidade.
          </p>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            2. Dados Coletados
          </h2>
          <p style={{ marginBottom: '15px' }}>Coletamos os seguintes tipos de dados:</p>
          <ul style={{ marginLeft: '20px', marginBottom: '24px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>
              <strong>Informações de Identificação:</strong> Nome, e-mail e, quando disponível, 
              URL da foto de perfil (via Google Sign-In ou Sign in with Apple)
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>Foto de perfil (opcional):</strong> Pode ser importada no primeiro login via Google, 
              enviada por você (câmera ou galeria) ou omitida. Você pode alterar ou remover a foto a 
              qualquer momento em <strong>Meu Perfil</strong>; ao remover, nenhuma imagem de perfil será 
              exibida no aplicativo, mesmo que o Google ainda mantenha uma foto na sua conta externa
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>Dados de Acervo:</strong> Informações sobre armas, munições, equipamentos 
              (número de série, calibre, fabricante, modelo)
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>Documentos:</strong> Fotos e arquivos de CR (Certificado de Registro), 
              CRAF (Certificado de Registro de Arma de Fogo), GT (Guia de Tráfego) e outros documentos relacionados
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>Registros de Treinamento:</strong> Dados sobre práticas de tiro, locais, datas e habitualidade
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>Dados de Dispositivo:</strong> Identificador único do usuário gerado pelo sistema
            </li>
          </ul>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            3. Como Coletamos os Dados
          </h2>
          <p style={{ marginBottom: '15px' }}>Os dados são coletados através de:</p>
          <ul style={{ marginLeft: '20px', marginBottom: '24px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>Formulários de cadastro dentro do aplicativo</li>
            <li style={{ marginBottom: '10px' }}>Upload de fotos via câmera ou galeria do dispositivo (documentos e foto de perfil)</li>
            <li style={{ marginBottom: '10px' }}>Autenticação via Google Sign-In (e-mail, nome e URL da foto, quando disponível)</li>
            <li style={{ marginBottom: '10px' }}>Autenticação via Sign in with Apple (e-mail e nome; a Apple não fornece foto de perfil)</li>
            <li style={{ marginBottom: '10px' }}>Sincronização automática com nossos servidores seguros</li>
          </ul>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            4. Uso dos Dados
          </h2>
          <p style={{ marginBottom: '15px' }}>Utilizamos seus dados exclusivamente para:</p>
          <ul style={{ marginLeft: '20px', marginBottom: '20px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>Gestão e controle do seu acervo de armas, munições e equipamentos</li>
            <li style={{ marginBottom: '10px' }}>Armazenamento seguro de documentos legais (CR, CRAF, GT)</li>
            <li style={{ marginBottom: '10px' }}>
              Registro de habitualidade em práticas de tiro para fins de conformidade legal
            </li>
            <li style={{ marginBottom: '10px' }}>Exibição de foto de perfil no aplicativo (quando você não optou por removê-la)</li>
            <li style={{ marginBottom: '10px' }}>Sincronização entre seus dispositivos (quando aplicável)</li>
            <li style={{ marginBottom: '10px' }}>Backup e recuperação de dados</li>
          </ul>
          <div style={{ 
            background: '#fef3c7', 
            padding: '16px 20px', 
            borderLeft: '4px solid #f59e0b',
            borderRadius: '6px',
            marginBottom: '24px'
          }}>
            <strong>Não utilizamos seus dados para marketing, publicidade ou qualquer outro propósito 
            não relacionado à gestão do seu acervo.</strong>
          </div>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            5. Compartilhamento com Terceiros
          </h2>
          <p style={{ marginBottom: '15px' }}>Seus dados são compartilhados APENAS nas seguintes situações:</p>
          <ul style={{ marginLeft: '20px', marginBottom: '20px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>
              <strong>Google Sign-In:</strong> E-mail, nome e URL da foto de perfil (quando disponível) 
              são recebidos do Google exclusivamente para autenticação e exibição inicial no app. Se você 
              remover a foto no ArsenalHub, deixamos de tratá-la e exibi-la na Plataforma
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>Nossos Servidores:</strong> Dados são armazenados em servidores próprios 
              (PostgreSQL, MinIO/S3) hospedados de forma segura
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>Autoridades Legais:</strong> Podemos compartilhar dados mediante ordem judicial 
              ou requisição legal da Polícia Federal
            </li>
          </ul>
          <div style={{ 
            background: '#fef3c7', 
            padding: '16px 20px', 
            borderLeft: '4px solid #f59e0b',
            borderRadius: '6px',
            marginBottom: '24px'
          }}>
            <strong>NÃO compartilhamos seus dados com empresas de marketing, analytics de terceiros 
            ou redes de publicidade.</strong>
          </div>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            6. Armazenamento e Segurança
          </h2>
          <p style={{ marginBottom: '15px' }}>Implementamos medidas de segurança rigorosas:</p>
          <ul style={{ marginLeft: '20px', marginBottom: '24px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>
              Criptografia AES-256 para dados sensíveis (números de série, caminhos de documentos)
            </li>
            <li style={{ marginBottom: '10px' }}>
              Tokens JWT armazenados de forma segura localmente via flutter_secure_storage
            </li>
            <li style={{ marginBottom: '10px' }}>
              Hash de senhas com Argon2 (nunca armazenamos senhas em texto plano)
            </li>
            <li style={{ marginBottom: '10px' }}>Comunicação HTTPS/TLS entre o aplicativo e servidores</li>
            <li style={{ marginBottom: '10px' }}>Backup automático criptografado</li>
            <li style={{ marginBottom: '10px' }}>
              Auditoria de todas as operações de criação, atualização e exclusão
            </li>
          </ul>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            7. Retenção e Exclusão de Dados
          </h2>
          <p style={{ marginBottom: '15px' }}>
            Seus dados são retidos enquanto sua conta estiver ativa. Você pode solicitar a exclusão 
            completa dos seus dados a qualquer momento através do menu de perfil ou entrando em contato conosco.
          </p>
          <p style={{ marginBottom: '15px' }}>Após a solicitação de exclusão:</p>
          <ul style={{ marginLeft: '20px', marginBottom: '24px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>
              Dados pessoais serão permanentemente removidos em até 30 dias
            </li>
            <li style={{ marginBottom: '10px' }}>
              Backups criptografados serão removidos no próximo ciclo de limpeza (até 90 dias)
            </li>
            <li style={{ marginBottom: '10px' }}>
              Logs de auditoria podem ser mantidos de forma anonimizada para conformidade legal
            </li>
          </ul>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            8. Seus Direitos (LGPD)
          </h2>
          <p style={{ marginBottom: '15px' }}>Você tem direito a:</p>
          <ul style={{ marginLeft: '20px', marginBottom: '20px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>Acessar todos os seus dados armazenados</li>
            <li style={{ marginBottom: '10px' }}>Corrigir dados incompletos ou incorretos</li>
            <li style={{ marginBottom: '10px' }}>Solicitar exclusão completa dos seus dados</li>
            <li style={{ marginBottom: '10px' }}>Revogar consentimento de uso de dados</li>
            <li style={{ marginBottom: '10px' }}>Portabilidade dos seus dados</li>
            <li style={{ marginBottom: '10px' }}>Informações sobre uso e compartilhamento dos seus dados</li>
            <li style={{ marginBottom: '10px' }}>
              Incluir, alterar ou remover sua foto de perfil diretamente em <strong>Meu Perfil</strong> no aplicativo
            </li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            <strong>Foto de perfil:</strong> a remoção elimina da Plataforma tanto fotos enviadas por você 
            quanto a exibição de foto importada do Google Sign-In. Nesse caso, passamos a exibir apenas um 
            avatar com suas iniciais. Essa escolha não será revertida automaticamente em logins futuros via Google, 
            salvo se você enviar uma nova foto voluntariamente.
          </p>
          <p style={{ marginBottom: '24px' }}>
            Para exercer esses direitos, acesse o menu de Perfil no aplicativo ou entre em contato conosco.
          </p>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            9. Dados de Menores
          </h2>
          <p style={{ marginBottom: '24px' }}>
            O ArsenalHub é destinado exclusivamente a maiores de 18 anos que possuam autorização legal 
            da Polícia Federal para posse/porte de armas. Não coletamos intencionalmente dados de menores de idade.
          </p>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            10. Alterações nesta Política
          </h2>
          <p style={{ marginBottom: '24px' }}>
            Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre mudanças 
            significativas através do aplicativo. A versão atualizada estará sempre disponível nesta página.
          </p>

          <h2 style={{ 
            color: '#1e293b', 
            marginTop: '40px', 
            marginBottom: '20px',
            fontSize: '24px',
            fontWeight: '700',
            paddingBottom: '12px',
            borderBottom: '3px solid #334155'
          }}>
            11. Contato
          </h2>
          <p style={{ marginBottom: '15px' }}>
            Para dúvidas, solicitações ou reclamações sobre privacidade, entre em contato:
          </p>
          <ul style={{ marginLeft: '20px', marginBottom: '32px', listStyle: 'disc' }}>
            <li style={{ marginBottom: '10px' }}>
              <strong>Email:</strong> privacidade@arsenalhub.com.br
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>DPO (Encarregado de Dados):</strong> dpo@arsenalhub.com.br
            </li>
          </ul>

          <div style={{ 
            background: '#dbeafe', 
            borderLeft: '4px solid #334155',
            padding: '20px',
            borderRadius: '8px',
            marginTop: '40px'
          }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              <span style={{ fontSize: '24px' }}>ℹ️</span>
              <div>
                <strong style={{ fontSize: '15px', display: 'block', marginBottom: '8px', color: '#1e293b' }}>
                  Conformidade Legal
                </strong>
                <p style={{ margin: '0', fontSize: '14px', color: '#475569', lineHeight: '1.6' }}>
                  Esta política está em conformidade com a LGPD (Lei nº 13.709/2018) e diretrizes 
                  internacionais de privacidade.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{ 
          marginTop: '40px',
          padding: '30px',
          background: '#1f2937',
          borderRadius: '12px',
          color: '#9ca3af',
          textAlign: 'center',
          fontSize: '13px'
        }}>
          <p style={{ marginBottom: '5px', fontWeight: '600', color: '#cbd5e1' }}>
            © {new Date().getFullYear()} ArsenalHub. Todos os direitos reservados.
          </p>
          <p style={{ marginBottom: '0', fontSize: '12px' }}>
            Este aplicativo é destinado exclusivamente a CACs autorizados pela Polícia Federal do Brasil.
          </p>
        </div>
      </div>
    </div>
  );
};
